export default __webpack_public_path__ + "static/media/afrmoney.bda568bc.png";